import { fetchUserFarmerPlan } from "@/apis";
import { createAsyncThunk } from "@reduxjs/toolkit";

// export const fetchFarmerPlan = createAsyncThunk("userFarmerPlan/fetch", async (userId)=>{
//     const  response = await fetchUserFarmerPlan(userId);
//     return response.data.response;
// })